var _circle, _circle2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMainIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 46 46"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 23,
  cy: 23,
  r: 21.5,
  stroke: "currentcolor",
  strokeWidth: 3
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 23,
  cy: 23,
  r: 18
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#main-icon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentcolor",
  d: "M33.676 17.28c.724-1.74.144-3.612-.855-4.003-.999-.39-2.751.55-3.473 2.288-.722 1.739-.632 3.418.855 4.002 1.486.585 2.75-.549 3.473-2.287m-2.412 6.452c-.559-2.402-2.586-3.982-4.924-3.459-1.602.357-1.812 1.92-2.976 2.18-1.164.262-2.276-1.006-3.866-.65-2.347.524-3.467 2.814-2.907 5.207.15.629.399 1.23.739 1.784q.237.393.525.752c2.661 3.348 6.965 4.401 6.965 4.401.367.067.744.06 1.108-.024a2.7 2.7 0 0 0 1.006-.456s3.41-2.771 4.318-6.923q.093-.446.14-.9a6.3 6.3 0 0 0-.128-1.922zm-3.906-10.107c-.11-2.07-1.584-3.683-2.774-3.625s-2.49 1.807-2.384 3.878c.106 2.07.999 3.709 2.77 3.622 1.772-.086 2.491-1.805 2.388-3.875m-7.135.427c-.874-2.03-2.947-3.114-4.112-2.632-1.164.482-1.816 2.687-.94 4.717s2.377 3.349 4.112 2.631c1.736-.717 1.816-2.684.94-4.716m-5.802 4.942c-1.392-1.231-3.345-1.337-4.053-.571-.707.765-.404 2.654.983 3.885s3.006 1.71 4.053.573c1.046-1.136.404-2.656-.983-3.887"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "main-icon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentcolor",
  d: "M10 10h24v24H10z"
})))));
export default SvgMainIcon;